export const submitIntegration = ({ token, id }) => ({
  HTTPMethod: "post",
  path: `/api/v1/conduit/integrations/${encodeURIComponent(id)}/submit`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
